<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center">
                <section class="mu-d-flex mu-flex-row">
                    <h1 class="mu-mb-00">User details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p>
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div class="mu-d-flex mu-justify-content-end"  v-if="!rolesTabActive && !roleError && !isLocked">
                        <div role="group" class="mcc-button-group mcc-button-group--spaced" >
                            <button class="mcc-button mcc-button--soft-warning" id="disableBtn" v-bind:class="{'d-none':(userDto.deleted != null)}" :disabled="isProcessing" @click="disableBtnClick()" title="Disable">
                                <mcc-icon name="unavailable" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Disable</span>
                            </button>
                            <button class="mcc-button mcc-button--primary" id="enableBtn" v-if="userDto.deleted != null" :disabled="isProcessing" @click="enableUser()" title="Enable">
                                <mcc-icon name="undo" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Enable</span>
                            </button>
                            <button class="mcc-button mcc-button--success" id="saveBtn" title="Save" v-if="userDto.deleted == null" :disabled="isSaveDisabled" type="button" @click="saveUser()">
                                <mcc-icon name="save" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Save</span>
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb" class="">
            <ol class="mcc-breadcrumb">
                <li>Users & groups</li>
                <li>
                    <a class="table-link" @click="redirectToList()">Users</a>
                </li>
                <li>{{userName}}</li>
                <li class="lastBredCrumpLi">
                </li>
            </ol>
        </nav>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
            
            <div class="mcc-row" v-show="fetchCall">
                <div class="mcc-col">
                    <div style="position:relative">
                        <form @submit.prevent="saveUser()" id="formId" novalidate>
                            <div class="mcc-card">
                                <div class="mcc-row">
                                    <div class="mcc-row mu-pl-07 mu-pt-06" v-show="fetchCall">
                                        <div class="mcc-col">
                                            <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-if="userDto.deleted != null" color="warning">
                                                <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                                <p>
                                                    <strong>Warning!</strong>
                                                    <br />This user has been disabled and cannot be changed.
                                                    <br />
                                                    Reason: {{userDto.deletedReason}}
                                                </p>
                                            </mcc-alert>
                                            <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-if="roleError" color="warning">
                                                <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                                <p>
                                                    <strong>Warning!</strong>
                                                    <br />This user has been deleted from keycloak and cannot be changed.
                                                </p>
                                            </mcc-alert>
                                            <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-if="isLocked" color="warning">
                                                <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                                <p>
                                                    <strong>Warning!</strong>
                                                    <br />This user has been locked in the identity provider and cannot be changed.
                                                </p>
                                                <div class="" v-if="isAdmin" style="margin-inline-start:auto">
                                                    <button class="mcc-button mcc-button--primary" id="unlockBtn" @click="handleUnlockBtnClick()" title="Unlock">
                                                        <mcc-icon name="return" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Unlock</span>
                                                    </button>
                                                </div>
                                            </mcc-alert>
                                        </div>
                                    </div>
                                    <div class="mcc-col-12">
                                        <div class="mcc-tabs mcc-tabs--bar mcc-tabs--vertical mcc-tabs--contained" style="min-height: 550px;" @change="handleTabChange($event)">
                                            <input type="radio" id="profileTab" name="as-default-tab-control" checked="">
                                            <input type="radio" id="propertiesTab" name="as-default-tab-control">
                                            <input type="radio" id="groupsTab" name="as-default-tab-control">
                                            <input type="radio" id="externalSystemTab" name="as-default-tab-control">
                                            <input type="radio" id="rolesTab" name="as-default-tab-control">
                                            <ul role="tablist" class="tabUlTag">
                                                <li role="tab">
                                                    <label for="profileTab" tabindex="0">
                                                        <span>Profile</span>
                                                    </label>
                                                </li>
                                                <li role="tab">
                                                    <label for="propertiesTab" tabindex="0">
                                                        <span>Properties</span>
                                                    </label>
                                                </li>
                                                <li role="tab">
                                                    <label for="groupsTab" tabindex="0">
                                                        <span>Groups</span>
                                                    </label>
                                                </li>
                                                <li role="tab" :disabled="!userMappingAvailable">
                                                    <label for="externalSystemTab" tabindex="0">
                                                        <span>External system user mappings</span>
                                                    </label>
                                                </li>
                                                <li role="tab" v-if="!roleError && hasAdminRole">
                                                    <label for="rolesTab" tabindex="0">
                                                        <span>Roles</span>
                                                    </label>
                                                </li>
                                            </ul>
                                            <div role="tabpanel" class="mu-m-05">
                                                <h2 class="mu-pb-03 mcc-card__title">
                                                    Profile
                                                </h2>
                                                <div class="mcc-row">
                                                    <div class="mcc-col mcc-col-12">
                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03  mfc-form-input-wrapper--width">
                                                            <label for="firstName">First name</label>
                                                            <input type="text" name="firstName" id="firstName" disabled :value="userDto.firstName" placeholder="First name">

                                                        </div>
                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03  mfc-form-input-wrapper--width">
                                                            <label for="surname">Surname</label>
                                                            <input type="text" name="surname" id="surname" disabled :value="userDto.surname" placeholder="Surname">

                                                        </div>
                                                        <div class="mfc-input-wrapper mfc-form-input-wrapper--width" >
                                                            <label for="mds_input_group_buttons">Email</label>
                                                            <div class="mfc-input-group">
                                                                <input id="mds_input_group_buttons" name="mds_input_group_buttons" type="text" :value="userDto.email" disabled>
                                                                <button type="button" class="mcc-button mcc-button--soft-secondary" @click="openMailTo(userDto.email)">Send</button>
                                                            </div>

                                                        </div>
                                                        <!-- <label class="font-weight-bold d-block">Email</label>
                                                        <a :href="`mailto:${userDto.email}`">{{userDto.email}}</a> -->
                                                        <div class="flatpickr flatpickrGap mfc-input-wrapper mfc-form-input-wrapper--width " >
                                                            <label for="outOfficeDate" class=" mb-0">Out of office between  <small> - Optional</small></label>
                                                            <div class="mfc-input-group flatpickr-date--width flatpickrInstance mfc-input-group--has-help-text mfc-input-group--has-validation-text">
                                                                <input type="text" class="flatpickr outOfficeDateInline" placeholder="Select Date.." :disabled="toggleStatus" data-input ref="outOfficeDate" id="outOfficeDate" name="outOfficeDate" @change="handleOutOfficeRangeChange($event)" @ready="handleOutOfficeRangeReady()">
                                                                <button type="button" class="mcc-button mcc-button--outline" data-toggle aria-label="date" :disabled="toggleStatus">
                                                                    <mcc-icon name="calendar" aria-hidden="true"></mcc-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="mfc-checkbox-wrapper mfc-form-input-container" id="sendEmailNotification" color="primary">
                                                            <input type="checkbox" id="sendEmail" class="mfc-switch" ref="sendEmailNotification" :disabled="toggleStatus" name="sendEmailNotification" :checked="userDto.sendEmailNotification" @change="userDto.sendEmailNotification = $event.target.checked">
                                                            <label for="sendEmail">Send email notification</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="tabpanel" class="mu-m-05">
                                                <h2 class="mu-pb-03 mcc-card__title">
                                                    Properties
                                                </h2>
                                                <div v-for="(property,index) in userDto.properties" :key="index">
                                                    
                                                    <div class="mcc-row" v-if="property.definition.type == 'FREE_TEXT'">
                                                        <div class="mcc-col">
                                                            <label for="selectPage" class="font-weight-bold mu-mt-2">{{property.definition.label}}</label>
                                                            <small v-show="!property.definition.mandatory"> - Optional</small>
                                                            <div class="mcc-row">
                                                                <div class="mcc-col ">
                                                                    <div class="mfc-input-wrapper mu-d-block marginTop0 mfc-form-input-container">
                                                                        <label :for="'properties['+index+'].value'" :class="property.definition.mandatory?'mfc-label--required':''">Value</label>
                                                                        <input type="text" :pattern="nameRegex" maxlength="50" ref="valueInput" :disabled="userDto.deleted != null || roleError || isLocked" :id="'properties['+index+'].value'" :name="'properties['+index+'].value'" :value="userDto.properties[index].value" @change="updateValue($event, index, property.definition.mandatory)" @click="updateValue($event, index, property.definition.mandatory)" :required="property.definition.mandatory">

                                                                    </div>

                                                                </div>
                                                                <div class="mcc-col ">
                                                                    <div class="mfc-input-wrapper mu-d-block marginTop0 mfc-form-input-container">
                                                                        <label :for="'properties['+index+'].description'" :class="property.definition.mandatory?'mfc-label--required':''">Description</label>
                                                                        <input type="text" :pattern="nameRegex" maxlength="100" ref="description" :disabled="userDto.deleted != null || roleError || isLocked" :id="'properties['+index+'].description'" :name="'properties['+index+'].description'" :value="userDto.properties[index].description" @change="updateDesc($event, index, property.definition.mandatory)" @click="updateDesc($event, index, property.definition.mandatory)" :required="property.definition.mandatory">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mcc-row" v-if="property.definition.type == 'SELECTION'">
                                                        <div class="mcc-col ">
                                                            <div v-show="!property.definition.mandatory">
                                                                <label for="selectPage" class="font-weight-bold mu-mt-2">{{property.definition.label}}</label>
                                                                <small v-show="!property.definition.mandatory"> - Optional</small>
                                                                <div class="mfc-slim-select-wrapper mfc-form-input-wrapper--width mu-position-relative mu-pr-04 dialogSlimSelect">
                                                                    <select class="slimSelectClass" ref="valueInput" :id="'properties['+index+'].value'" :name="'properties['+index+'].value'" @change="userDto.properties[index].value = $event.target.value" :disabled="userDto.deleted != null || roleError || isLocked" block required="false" :label="property.definition.label">
                                                                        <option value=" " :selected="userDto.properties[index].value ==' '"></option>
                                                                        <option v-for="(option,key) in property.definition.options" :key="key" :selected="userDto.properties[index].value == option.value" :value="option.value">{{option.value}} - {{option.description}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div v-show="property.definition.mandatory">
                                                                <label for="selectPage" class="mfc-label--required font-weight-bold mu-mt-2">{{property.definition.label}}</label>
                                                                <div class="mfc-slim-select-wrapper mfc-form-input-wrapper--width mu-pr-04 mu-position-relative dialogSlimSelect">
                                                                    <select class="slimSelectClass" ref="valueInput" :id="'properties['+index+'].value'" :name="'properties['+index+'].value'" @change="userDto.properties[index].value = $event.target.value" :disabled="userDto.deleted != null || roleError || isLocked" block required="true" :label="property.definition.label">
                                                                        <option v-for="(option,key) in property.definition.options" :key="key" :selected="userDto.properties[index].value == option.value" :value="option.value">{{option.value}} - {{option.description}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="tabpanel" class="mu-m-05">
                                                <h2 class="mu-pb-03 mcc-card__title">
                                                    Groups
                                                </h2>
                                                <div class="mcc-row">
                                                    <div class="mcc-col ">
                                                        <form novalidate>
                                                            <Picklist :disabled="userDto.deleted != null || roleError || isLocked" ref="groupList" label=" " id="groupList" name="groupList" multiple filter></Picklist>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="tabpanel" class="mu-m-05">
                                                <h2 class="mu-pb-03 mcc-card__title">
                                                    External system user mappings
                                                </h2>
                                                <div class="mfc-slim-select-wrapper mfc-form-input-wrapper--width mu-position-relative dialogSlimSelect">
                                                    <label for="selectPage" class=" mu-mb-00">External system</label>
                                                    <select :disabled="userDto.deleted != null || roleError || isLocked" v-if="userMappingAvailable" @change="handleExternalSysChange($event.target.value)" id="externalSystems" ref="externalSystems" name="externalSystems" block label="External system">
                                                        <option :value="ele.externalSystem.name" v-for="(ele,index) in systemUserDetailList" :key="index" :selected="index == 0">{{ele.externalSystem.name}}</option>
                                                    </select>
                                                </div>
                                                <div class="mcc-row" v-if="userMappingAvailable && showUserMappingFields">
                                                    <div class="mcc-col">
                                                        <div class="mfc-textarea-wrapper marginTop0 mfc-form-input-container mfc-form-input-wrapper--width">
                                                            <label for="extSysDesc">Description</label>
                                                            <textarea id="extSysDesc" name="extSysDesc" ref="extSysDesc" placeholder="Description" readonly="" :value="selExtSys.externalSystem.description"></textarea>
                                                        </div>
                                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width" >
                                                            <label for="userNameAlias">User name alias</label>
                                                            <input type="text" id="userNameAlias" name="userNameAlias" ref="userNameAlias" maxlength="50" :disabled="userDto.deleted != null || roleError || isLocked" :value="selExtSys.username" @change="checkAlias($event)" :pattern="nameRegex">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="tabpanel" class="mu-m-05">
                                                <h5 class="mu-pb-03 mcc-card__title">
                                                    Roles
                                                </h5>
                                                <div style="position:relative">
                                                    <div v-if="updateRoleCall" class="spinner-overlay">
                                                        <div class="spinner-background"></div>
                                                        <div class="spinner-flex">
                                                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <div class="mcc-row">
                                                        <div class="mcc-col mcc-col-md-8">
                                                            <form novalidate>
                                                                <Picklist :disabled="userDto.deleted != null || roleError || isLocked" ref="rolesList" label=" " id="rolesList" name="rolesList" multiple filter :handleChange="handleRoleChange"></Picklist>
                                                            </form>
                                                        </div>
                                                        <div class="mcc-col mcc-col-md-4">
                                                            <div class="mcc-row">
                                                                <div class="mcc-col" v-if="!updateRoleCall">
                                                                    <div class="effRoleCont">
                                                                        <label class="d-block effRoleLabel">Effective roles</label>
                                                                        <div class="my-1" v-for="(ele,index) in effectiveRoles" :key="index">
                                                                            <span class="mcc-chip mcc-chip--success">{{ele}}</span>
                                                                        </div>
                                                                        <small v-show="effectiveRoles.length <= 0">No role assigned</small>
                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </form>
                    </div>

                </div>

            </div>
        </div>

    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--warning" @show="showDialog" id="disableUserModal" ref="disableUserModal">
            <form novalidate id="disableUserForm" ref="disableUserFormRef">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Disable</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div>
                                    <div class="mfc-textarea-wrapper mfc-form-input-container">
                                        <label for="disableReason"  class=" mfc-label--required">Disable reason</label>
                                        <textarea id="disableReason" ref="disableReason" name="disableReason" required="" maxlength="100" rows="6" :pattern="descRegex" :value="deletedReason" @change="updateReason($event)" @input="deletedReason = $event.target.value" character-count=""></textarea>
                                        <div class="mfc-invalid-feedback"></div>
                                        <div class="mfc-help-text mu-mt-00">
                                            <span>You have {{100 - deletedReason.length}} characters remaining</span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeDialog()">Close</button>
                            <button type="button" class="mcc-button mcc-button--warning" @click="disableUser()">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import UserAPI from '../../../services/UserAPI';
import Utils from "@/script_utils";
import moment from 'moment';
import {
    displayErrorMessage,checkFormAndTextareaValidations
} from '../../../formvalid.js';
import Picklist from "../../customComponents/Picklist.vue";

export default {
    name: "UserEdit",
    components:
    {
        Picklist
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["usersgroups.users.edit"],
            descRegex: constantMessages.PATTERNS["description"],
            properties_name: constantMessages.PATTERNS["properties_name"],
            nameRegex: constantMessages.PATTERNS["name"],
            userDto: {},
            userName: "",
            userId: this.$route.params.userId,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            deletedReason: "",
            fetchCall: false,
            allGroupName: [],
            selectedGroupsName: [],
            groupList: [],
            userMappingAvailable: true,
            systemUserDetailList: [],
            selExtSys: {},
            showUserMappingFields: false,
            allRoles: [],
            effectiveRoles: [],
            assignedRoles: [],
            rolesTabActive: false,
            hasRolesData: false,
            updateRoleCall: false,
            updateDialog: false,
            outOfOfficeRef: [],
            updateCall: false,
            roleError: false,
            isLocked: false,
            isAdmin: false,
            hasAdminRole: false,
            flatPickerInstance: null,
            toggleStatus: false,
            isProcessing: false,
            isUserNameAliasValid: true
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.flatPickr();
        this.getUserDetails();
    },
    // updated() {
    //     this.flatPickr();
    //     this.initSlimSelectForClass('.slimSelectClass');
    // },
    watch: {
        'userDto.deleted': function(newValue) {
            this.updateToggleStatus();
        },
        roleError: function(newValue) {
            this.updateToggleStatus();
        },
        isLocked: function(newValue) {
            this.updateToggleStatus();
        }
    },
    computed: {
        isSaveDisabled() {
            return !this.validateProperties() || this.isProcessing || this.userDto.deleted !== null ||
            !this.isUserNameAliasValid;
        }
    },
    methods: {
        isValidProperty(property) {
            const regex = /^(?!\s)(?!.*\s$)[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/;
            
            // If the property is mandatory, both value and description must match the regex.
            if (property.definition && property.definition.mandatory) {
                return regex.test(property.value) && regex.test(property.description);
            } else {
                // For non-mandatory properties:
                // Treat undefined or blank (after trimming) as valid.
                const valueIsBlank = !property.value || property.value.trim() === "";
                const descIsBlank = !property.description || property.description.trim() === "";
                
                // If both are blank, it's valid.
                if (valueIsBlank && descIsBlank) {
                return true;
                }
                
                // If any field is not blank, then it must pass the regex validation.
                const valueValid = valueIsBlank || regex.test(property.value);
                const descValid = descIsBlank || regex.test(property.description);
                
                return valueValid && descValid;
            }
            },
        validateProperties() {
            return this.userDto?.properties
                ?.filter(prop => prop.definition.type === "FREE_TEXT")
                ?.every(prop => this.isValidProperty(prop)) ?? false;
        },
        initSlimSelect(selector) {
            if (!document.querySelector(selector)._slim) {
                new SlimSelect({
                    select: selector
                });
            }
        },
        initSlimSelectForClass(className) {
            document.querySelectorAll(className).forEach((element) => {
                if (!element._slim) {
                    new SlimSelect({
                        select: element
                    });
                }
            });
        },
        updateToggleStatus() {
            if (this.userDto.deleted != null || this.roleError || this.isLocked) {
                this.toggleStatus = true; 
                this.$refs.outOfficeDate.disabled = true;
                document.querySelectorAll('.outOfficeDateInline').forEach((element) => {
                    element.disabled = true;
                });
            } else {
                this.toggleStatus = false;
                this.$refs.outOfficeDate.disabled = false;
                document.querySelectorAll('.outOfficeDateInline').forEach((element) => {
                    element.disabled = false;
                });
            }
        },
        updateDescription(event) {
            if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(this.$refs.extSysDesc), "Description must be valid")
                this.$refs.extSysDesc.classList.add("ms-is-invalid")

            } else {
                self.$refs.extSysDesc.classList.remove("ms-is-invalid")
            }
        },
        updateReason(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason is required")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else if (!event.target.value.match(this.descRegex)) {
                displayErrorMessage($(self.$refs.disableReason), "Disable reason must be valid")
                self.$refs.disableReason.classList.add("ms-is-invalid")
                self.invalidDisableReason = true;
            } else {
                self.$refs.disableReason.classList.remove("ms-is-invalid")
                self.invalidDisableReason = false;
            }
            self.deletedReason = event.target.value;
        },
        updateDesc(event, fieldIndex, isMandatory) {
            let self = this;
            let propertyId = "properties[" + fieldIndex + "].description";
            let index = self.$refs.description.findIndex(el => el.id === propertyId);
            let inputValue = event.target.value;
            const regex = /^(?!\s)(?!.*\s$)[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/;
            
            if (isMandatory && inputValue === "") {
                displayErrorMessage(
                $(self.$refs.description[index]),
                constantMessages.MESSAGES["error.description.required"]
                );
                self.$refs.description[index].classList.add("ms-is-invalid");
            }
            else if (inputValue !== "" && !inputValue.match(regex)) {
                displayErrorMessage(
                $(self.$refs.description[index]),
                constantMessages.MESSAGES["error.description.invalid"]
                );
                self.$refs.description[index].classList.add("ms-is-invalid");
            }
            else {
                self.$refs.description[index].classList.remove("ms-is-invalid");
            }
            
            self.userDto.properties[fieldIndex].description = inputValue;
        },
        updateValue(event, fieldIndex, isMandatory) {
            let self = this;
            let propertyId = "properties[" + fieldIndex + "].value";
            let index = self.$refs.valueInput.findIndex(el => el.id === propertyId);
            let inputValue = event.target.value;
            const regex = /^(?!\s)(?!.*\s$)[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/;

            if (isMandatory && inputValue === "") {
                displayErrorMessage(
                $(self.$refs.valueInput[index]),
                constantMessages.MESSAGES["error.value.required"]
                );
                self.$refs.valueInput[index].classList.add("ms-is-invalid");
            }
            else if (inputValue !== "" && !inputValue.match(regex)) {
                displayErrorMessage(
                $(self.$refs.valueInput[index]),
                constantMessages.MESSAGES["error.value.invalid"]
                );
                self.$refs.valueInput[index].classList.add("ms-is-invalid");
            }
            else {
                self.$refs.valueInput[index].classList.remove("ms-is-invalid");
            }
            
            self.userDto.properties[fieldIndex].value = inputValue;
            },
        checkAlias(event) {
            let self = this;
            let value = event.target.value;
            
             if (value.trim() === "") {
                self.$refs.userNameAlias.classList.remove("ms-is-invalid");
                this.isUserNameAliasValid = true;
            } else if (!value.match(/^(?!\s)(?!.*\s$)[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/)) {
                this.isUserNameAliasValid = false;
                displayErrorMessage($(self.$refs.userNameAlias), constantMessages.MESSAGES["error.value.invalid"]);
                self.$refs.userNameAlias.classList.add("ms-is-invalid");
            } else {
                self.$refs.userNameAlias.classList.remove("ms-is-invalid");
                this.isUserNameAliasValid = true;
            }
            
            self.selExtSys.username = value;
        },
        flatPickr() {
            let self = this;
            self.flatPickerInstance = flatpickr('.flatpickrInstance', {
                dateFormat: 'm/d/Y',
                altFormat: 'd/m/Y',
                altInput: true,
                mode: 'range',
                wrap:true,
                defaultDate: [self.outOfOfficeRef[0], self.outOfOfficeRef[1]],
            })
        },
        async loadGroups() {
            let self = this;

            await this.$nextTick();
            setTimeout(function () {
                self.$refs.groupList.setData(self.allGroupName,self.selectedGroupsName);
                self.updateCall = true;
            }, 2000);
        },
        async loadRoles() {
            let self = this;

            await this.$nextTick();
            setTimeout(function () {
                self.$refs.rolesList.setData(self.allRoles,self.assignedRoles);
                self.updateRoleCall = false;
            }, 2000);
        },
        getUserDetails() {
            let self = this;
            self.allGroupName = [];
            self.groupList = [];
            self.selectedGroupsName = [];
            self.systemUserDetailList = [];
            self.fetchCall = false;
            self.hasRolesData = false;
            self.updateCall = false;
            UserAPI.getUserDetails(this.$route.params.userId)
                .then(result => {
                    if (result == null) {
                        self.redirectToList();
                        EventBus.$emit('error-notification', {
                            "msg": "Error while fetching user"
                        });
                        return;
                    }
                    self.hasAdminRole = self.$store.getters.getRoleAdmin;
                    self.dataLoaded = true;
                    self.userDto = result.user;
                    self.roleError = result.roleError;
                    self.isLocked = result.isLocked;
                    self.isAdmin = result.isAdmin;
                    if (self.userDto.outOfOfficeStartDate != null && self.userDto.outOfOfficeEndDate != null) {
                        self.outOfOfficeRef[0] = new Date(self.userDto.outOfOfficeStartDate);
                        self.outOfOfficeRef[1] = new Date(self.userDto.outOfOfficeEndDate);
                        this.flatPickr()
                    }
                    self.userName = self.userDto.username;
                    self.userMappingAvailable = result.userMappingAvailable;
                    result.availableGroups.forEach(function (avalGrp, index) {
                        if (avalGrp.deleted != null || avalGrp.name == "PUBLIC") {
                            self.allGroupName.push({
                                "text": avalGrp.name,
                                "disabled": true
                            });
                        } else {
                            self.allGroupName.push({
                                "text": avalGrp.name
                            });
                        }
                        self.groupList.push(avalGrp);
                    });
                    self.userDto.groups.forEach(function (selGrp, index) {
                        self.selectedGroupsName.push(selGrp.name);
                        if (selGrp.deleted != null || selGrp.name == "PUBLIC") {
                            self.allGroupName.push({
                                "text": selGrp.name,
                                "disabled": true
                            });
                        } else {
                            self.allGroupName.push({
                                "text": selGrp.name
                            });
                        }
                        self.groupList.push(selGrp);
                    });
                    self.userDto.systemUserDetails.forEach(function (sysUserDetail, index) {
                        if (sysUserDetail.externalSystem.requiresUserMapping) {
                            self.systemUserDetailList.push(sysUserDetail);
                        }
                    });
                    if (self.systemUserDetailList.length > 0) {
                        self.selExtSys = self.systemUserDetailList[0];
                        self.showUserMappingFields = true;
                    }
                    let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.user.details"] + " - " + self.userName;
                    EventBus.$emit("update-pageTitle", pageTitle);
                })
                .finally(() => {
                    if (self.dataLoaded) {
                        self.fetchCall = true;
                        self.loadGroups();
                    }
                    self.initSlimSelect('#externalSystems');
                    self.initSlimSelectForClass('.slimSelectClass');
                });
        },
        disableBtnClick() {
            this.deletedReason = "";
            this.$refs.disableUserFormRef.classList.remove("ms-was-validated")
            this.$refs.disableReason.classList.remove("ms-is-invalid")
            this.$refs.disableUserModal.show();
        },
        closeDialog() {
            this.$refs.disableUserModal.close()
            this.updateDialog = false;
        },
        showDialog() {
            this.updateDialog = true;
        },
        handleExternalSysChange(selectedExtSysName) {
            this.showUserMappingFields = false;
            this.selExtSys = this.systemUserDetailList.find(obj => obj.externalSystem.name == selectedExtSysName);
            this.updateShowUserMappingFields();
        },
        async updateShowUserMappingFields() {
            await this.$nextTick();
            this.showUserMappingFields = true;
        },
        handleOutOfficeRangeChange(e) {
            this.outOfOfficeRef = "";
            if (e.target.value.length > 1) {
                this.outOfOfficeRef = e.target.value.split('to');
            }
        },
        handleOutOfficeRangeReady() {
            if (this.outOfOfficeRef.length > 1) {
                this.$refs.outOfficeDate.value =
                    moment(this.outOfOfficeRef[0]).format("DD/MM/YYYY") +
                    " to " +
                    moment(this.outOfOfficeRef[1]).format("DD/MM/YYYY");
            }
        },
        saveUser() {
            let form = $('#formId')
            let self = this;
             
            if(this.selExtSys.username){
                if(!checkFormAndTextareaValidations('userNameAlias',this.nameRegex,form)){
                    return;
                }
            }
            if (self.outOfOfficeRef.length > 0) {
                let outOfOfficeStartDate = self.outOfOfficeRef[0];
                let outOfOfficeEndDate = self.outOfOfficeRef[1];
                this.userDto.outOfOfficeStartDate = moment(outOfOfficeStartDate).format('YYYY-MM-DD');
                this.userDto.outOfOfficeEndDate = moment(outOfOfficeEndDate).format('YYYY-MM-DD');
            }
            self.userDto.groups = [];
            self.$refs.groupList.value.forEach(function (selGrpName, index) {
                self.userDto.groups.push(self.groupList.find(obj => (obj.name == selGrpName.text || obj.name == selGrpName)));
            });
            this.isProcessing = true;
            this.fetchCall = false;
            UserAPI.saveUser(self.userDto, self.userId).then(response => {
 
                if (response.error) {
                    EventBus.$emit("error-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    self.getUserDetails();
                }
            })
            .catch(() => {
                this.fetchCall = true;
            })
            .finally(() => {
                this.fetchCall = true;
                this.isProcessing = false;  
            });
        },
        handleTabChange(e) {
            let self = this;
            if (e.target.id == "rolesTab") {
                self.rolesTabActive = true;
                if (!self.hasRolesData) {
                    self.updateRoleCall = true;
                    self.allRoles = [];
                    self.effectiveRoles = [];
                    self.assignedRoles = [];
                    UserAPI.getRolesByUser(this.$route.params.userId)
                        .then(result => {
                            self.roleError = result.roleError;
                            if (!result.roleError) {
                                self.updateRoleData(result);
                            }
                        }).finally(() => {
                            self.hasRolesData = true;
                            self.loadRoles();
                        });
                }
            } else if (e.target.type !== 'checkbox') {
                self.rolesTabActive = false;
            }
        },
        handleRoleChange(changeType, allUserRoles) {
            let self = this;
            self.updateRoleCall = true;
            self.allRoles = [];
            self.effectiveRoles = [];
            self.assignedRoles = [];
            UserAPI.updateRoles(self.userId, changeType, allUserRoles).then(result => {
                self.roleError = result.roleError;
                if (!result.roleError) {
                    self.updateRoleData(result);
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES["message.role.save"]
                    });
                } else {
                    EventBus.$emit("error-notification", {
                        msg: constantMessages.MESSAGES["message.role.save.error"]
                    });
                }
            }).finally(() => {
                self.loadRoles();
            });
        },
        redirectToList() {
            localStorage.setItem("UserList", "userList");

            this.$router.push(
                this.CONTEXT_PATH + '/usersgroups/users'
            );
        },
        updateRoleData(result) {
            let self = this;
            result.availableRoles.forEach(function (avalRole, index) {
                self.allRoles.push({
                    "text": avalRole.roleName
                });
            });
            result.assignedRoles.forEach(function (assignedRole, index) {
                self.assignedRoles.push(assignedRole.roleName);
                if (assignedRole.roleName == "ROLE_USER") {
                    self.allRoles.push({
                        "text": assignedRole.roleName,
                        "disabled": true
                    });
                } else {
                    self.allRoles.push({
                        "text": assignedRole.roleName
                    });
                }
            });
            result.effectiveRoles.forEach(function (effectRoles, index) {
                self.effectiveRoles.push(effectRoles.roleName);
            });
        },
        disableUser() {
            
            let form = $('#disableUserForm')

            if(!checkFormAndTextareaValidations('disableReason',this.descRegex,form))
            {
                return;
            }
            this.isProcessing = true;
            let self = this;
            return UserAPI.disableUser(
                self.userId,
                self.deletedReason
            ).then(response => {
                if (!response.error) {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    document.getElementById("disableUserModal").close();
                    self.redirectToList();
                } else {
                    EventBus.$emit("error-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                }
            })
            .finally(() => {
                this.isProcessing = false; 
            });
        },
        enableUser() {
            let self = this;
            self.fetchCall = false;
            self.updateCall = false;
            this.isProcessing = true;
            return UserAPI.enableUser(self.userId)
                .then(response => {
                    if (!response.error) {
                        self.userDto.deletedReason = null;
                        self.userDto.deleted = null;
                        self.userDto.version = response.data;
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    }
                })
                .finally(() => {
                    self.fetchCall = true;
                    this.isProcessing = false;
                    self.loadGroups();
                    self.loadRoles();
                });
        },
        handleUnlockBtnClick() {
            let self = this;
            self.fetchCall = false;
            self.updateCall = false;
            return UserAPI.unlockUser(self.userId)
                .then(response => {
                    if (!response.error) {
                        self.isLocked = false;
                        EventBus.$emit("success-notification", {
                            msg: "User unlocked successfully"
                        });
                    } else {
                        EventBus.$emit("error-notification", {
                            msg: "Error occurred while unlocking user in identity provider"
                        });
                    }
                })
                .finally(() => {
                    self.fetchCall = true;
                    self.loadGroups();
                    self.loadRoles();
                });
        },
        openMailTo(email) {
            let mailTo = "mailto:" + email + ""
            window.location = mailTo;
        }
    }
};
</script>

<style scoped>
.effRoleCont {
    border: 1px solid #ccc;
    padding: 15px;
}

.effRoleLabel {
    border-bottom: 1px solid #ccc;
    margin-bottom: 15px;
    font-size: 13px;
}

.marginTop0 {
    margin-top: 0 !important;
}

.tabUlTag {
    border-style: unset !important;
}

div[role=tabpanel] {
    width: 100%
}


.outOfficeDateInline:disabled {
    background-color: #eeeef1; /* Light grey background */
}
</style>
